import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../../contexts/AuthContext';
import { useWarehouse } from '../../../../contexts/WarehouseContext';
import { ItemCardSearch } from './ItemCardSearch';
import { ItemCardView } from './ItemCardView';

interface ItemCardProps {
  onBack?: () => void;
}

/** Dyplenke inn (leses kun ved åpning) — adressefeltet skrives ikke, som i resten av appen. */
const readItemNoFromUrl = (): string | null => {
  const value = new URLSearchParams(window.location.search).get('itemNo');
  return value && value.trim() ? value.trim() : null;
};

/**
 * Varekort v2 (Plan-Varekort-v2.md). Én modul, to visninger: operatør og lagersjef
 * (OperatorGroupId 2/3 — samme regel som getDefaultDashboard). Rollen avgjør også hva
 * endepunktet returnerer (server-side).
 * Dyplenke inn: ?module=item-card&itemNo=X[&tab=history]. Valgt vare/fane holdes i minnet.
 */
export const ItemCard: React.FC<ItemCardProps> = ({ onBack }) => {
  const { user } = useAuth();
  const { currentWarehouse } = useWarehouse();
  const [itemNo, setItemNo] = useState<string | null>(readItemNoFromUrl);

  // Dyplenken er brukt opp når den er lest: fjern itemNo/tab fra adressen, så en senere omstart av
  // modulen (klikk på Varekort i menyen) gir søket — ikke samme vare igjen. ?module= blir stående.
  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('itemNo') && !url.searchParams.has('tab')) return;
    url.searchParams.delete('itemNo');
    url.searchParams.delete('tab');
    window.history.replaceState(window.history.state, '', url.toString());
  }, []);

  const isManager = user?.operatorGroupId === '2' || user?.operatorGroupId === '3';
  // Operatørmoduler ser bare aktivt lager (TW 36386708); lagersjef ser alle lagre.
  const warehouseId = isManager ? null : currentWarehouse;

  const select = useCallback((value: string) => setItemNo(value), []);
  const clear = useCallback(() => setItemNo(null), []);

  return (
    <div className="min-h-full">
      {itemNo ? (
        <ItemCardView itemNo={itemNo} warehouseId={warehouseId} isManager={isManager} onBack={clear} />
      ) : (
        <ItemCardSearch onSelect={select} onBack={onBack} />
      )}
    </div>
  );
};
